import actions from "@/store/modules/order-service/actions";

export default {
    actions
}